"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISPLAYABLE_PAYMENT_METHOD_TYPES = void 0;
const payment_enums_1 = require("../enums/payment.enums");
exports.DISPLAYABLE_PAYMENT_METHOD_TYPES = [payment_enums_1.PaymentMethodTypeEnum.ACH, payment_enums_1.PaymentMethodTypeEnum.CARD];
//# sourceMappingURL=user-payment-method.consts.js.map